import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Paper } from '@mui/material';
import { withStyles } from '@mui/styles';
import palette from '../../theme/palette';
const styles = theme => {
  return {
    root: {
      borderRadius: '4px'
    },
    squared: {
      borderRadius: 0
    },
    outlined: {
      border: `1px solid ${palette.border}`
    }
  };
};

const CustomPaper = ({ 
  classes, 
  className, 
  outlined = true, 
  squared = false, 
  children, 
  userData, 
  enqueueSnackbar, 
  closeSnackbar, 
  filledError, 
  elevation = 0,
  ...rest 
}) => {

  const rootClassName = classNames(
    {
      [classes.root]: true,
      [classes.squared]: squared,
      [classes.outlined]: outlined
    },
    className
  );

  return (
    <Paper
      {...rest}
      className={rootClassName}
    >
      {children}
    </Paper>
  );
};

CustomPaper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  elevation: PropTypes.number,
  outlined: PropTypes.bool,
  squared: PropTypes.bool,
  userData: PropTypes.object,
  enqueueSnackbar: PropTypes.func,
  closeSnackbar: PropTypes.func,
  filledError: PropTypes.object
};

// Default props removed - using default parameters instead

export default withStyles(styles)(CustomPaper);
